/**
 *
 * @module adobeIdentityClientEndpoint
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef AdobeIdentityClientEndpoint
 * @type {Object}
 *
 * @property {String} getAdobeRegistration
 * @property {String} getIdentityToken
 *
 */

/**
 *
 * @enum
 * @type {AdobeIdentityClientEndpoint}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    getAdobeRegistration: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    getIdentityToken: null
});



// WEBPACK FOOTER //
// ./src/services/identity/adobe/adobeIdentityClientEndpoint.js